import { httpClient } from "@/api/httpClient";

export function fetchCategories() {
  return httpClient.get("/categories", {
    params: {
      asc: "createdAt",
    },
  });
}

export function createCategory(data) {
  return httpClient.post("/categories", data);
}

export function updateCategory(id, data) {
  return httpClient.patch(`/categories/${id}`, data);
}

export function deleteCategory(id) {
  return httpClient.delete(`/categories/${id}`);
}
